
import wixData from 'wix-data';

let mainMenuItems = [];

$w.onReady(async () => {
	mainMenuItems = (await wixData.query('MainMenu').include('subMenu').find()).items;
	$w('#mainMenu').data = mainMenuItems;
});


export function mainMenu_itemReady($item, itemData, index) {
	$item('#menuButton').label = itemData.title;
	$item('#menuButton').link = itemData.url;
	console.log(itemData);
	if (itemData.subMenu.length > 0) {
		$item('#table1').columns = [{id: "title", label: "Title", type: "string", dataPath: "title", visible: true, linkPath: "url"}];
		$item('#table1').rows = itemData.subMenu.map(s=>{
			s.url = "https://www.bestsite.co.il" + s.url
			return s;
		});
	} else {
		$item('#table1').rows = [];
	}
}

export function button5_mouseIn(event) {
	let $item = $w.at(event.context);
	if (event.target.label === "תיק עבודות") {
		$w('#repeater7').show();
		$w('#repeater7').expand();
	} else if ($item('#table1').rows.length > 0) {
		$w('#table1').hide();
		$item('#table1').expand();
		$item('#table1').show();
	}
}

export function button5_mouseOut(event) {
	let $item = $w.at(event.context);
	if (event.target.label === "תיק עבודות") {
		$w('#repeater7').hide();
		$w('#repeater7').collapse();
	} else if ($item('#table1').rows.length > 0) {
		$item('#table1').hide();
		$item('#table1').collapse();
	}
}

export function table1_mouseIn(event) {
	event.target.show();
	event.target.expand();
}

export function table1_mouseOut(event) {
	event.target.hide();
	event.target.collapse();
}

export function repeater7_mouseOut(event) {
	$w('#repeater7').hide();
	$w('#repeater7').collapse();
}

export function repeater7_mouseIn(event) {
	$w('#repeater7').show();
	$w('#repeater7').expand();
}

export function table1_rowSelect(event) {
	event.target.hide();
	event.target.collapse();
}